import palette from "../palette";

export default {
  styleOverrides: {
    data: {
      color: palette.primary.main,
    },
    root: {
      color: palette.primary.main,
    }
  }
};
